import styled from "styled-components";

import ButtonMenu from "@/components/atoms/Button/ButtonMenu/ButtonMenu";
import { breakpoints } from "@/styles/breakpoints";

export const StyledAuthPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: var(--color-grey-400);
`;

export const StyledMainHeader = styled.header`
    position: sticky;
    top: 0;
    z-index: 25;
    background-color: var(--color-white);
`;

export const StyledSubHeader = styled.div<{ $isDesktop: boolean }>`
    ${(props) =>
        props.$isDesktop &&
        `
            position: sticky;
            top: 63px;
            z-index: 25;
        `}
`;

export const StyledAuthPageBody = styled.main`
    flex: 1;
    display: flex;
    /* margin-top: 16px; MYBR-6934*/
`;

export const StyledPageContainer = styled.div`
    max-width: var(--max-page-width);
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;
    margin: 0 auto;
    background-color: var(--color-grey-400);
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const StyledHeaderMenuButton = styled(ButtonMenu)`
    color: var(--color-primary-fg);

    .text {
        margin-left: 1rem;
        display: flex;
        align-items: center;
        color: var(--color-primary-fg);
    }

    .arrowIcon {
        margin-left: 1rem;

        path {
            fill: var(--color-primary-fg);
        }

        @media ${breakpoints.xs} {
            margin-left: 0.49rem;
        }
    }

    .icon {
        display: flex;

        @media ${breakpoints.xs} {
            display: none;
        }

        path {
            fill: var(--color-primary-fg);
        }
    }
`;

export const StyledBaseHeader = styled.div`
    .logo {
        display: flex;
        height: 100%;
        padding: 0;

        &:hover {
            background-color: unset;
        }
    }

    select {
        color: var(--color-primary-fg);

        option {
            color: var(--color-primary);
        }
    }

    .row {
        height: inherit;
    }

    .header-components-action {
        height: inherit;
    }
`;
